var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"status-badge",class:_vm.statusClass},[_c('span',{staticClass:"status-dot"}),_vm._v(" "+_vm._s(_vm.displayLabel)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }